import { boAPI } from 'constants/api';
import fetchApi from 'services/fetch';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const initialState = {
  clientInfo: {},
  homeDebt: [],
  mobileDebt: [],
};

export const clientInformation = {
  state: { ...initialState },
  reducers: {
    setHomeDebt(state, payload) {
      return { ...state, homeDebt: payload };
    },
    setMobileDebt(state, payload) {
      return { ...state, mobileDebt: payload };
    },
    clearCurrentInfo() {
      return {
        ...initialState,
      };
    },
  },
  effects: (dispatch) => {
    return {
      async getClientDebts({ type, id }, state) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'get',
          url: boAPI.getClientDebts
            .replace(':customerType', type)
            .replace(':identificationType', 'nit')
            .replace(':identificationID', id),
          params: { hasPayment: false },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            if (type === 'home') this.setHomeDebt(response?.data);
            else if (type === 'mobile') this.setMobileDebt(response?.data);
            return Promise.resolve({ success: true, existingDebt: true });
          })
          .catch((error) => {
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Get Client Debt',
                boAPI.getClientDebts,
                'Get Client Creditscore API'
              ),
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Client Debt') });
            
            const code = error?.rawResponse?.code || error?.errorCode;
            if (type === 'home' && [2026].includes(code)) {
              return Promise.resolve({ success: true, newClient: true });
            } else if (type === 'mobile' && ['GBIM-0003'].includes(code)) {
              return Promise.resolve({ success: true, newClient: true });
            }  else if (type === 'home' && [404].includes(error.errorCode)) {
              return Promise.resolve({ success: true, existingClient: true });
            } else if (type === 'mobile' && ['GBIM-0002'].includes(code)) {
              return Promise.resolve({ success: true, existingClient: true });
            } else {
              dispatch.apiStatus.setRequestFailed({ ...error });
              return Promise.resolve({ success: false });
            }
          });
      },
      async validateClient(params, state) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'get',
          url: boAPI.validateClient,
          params: {
            recipeId: 'home-validate-document',
            ...params,
          },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            const decision = response?.data?.data?.eligibilityDecisions?.decisionContent;
            if (decision?.status === 'acepted' && decision?.rejectCode === 2) {
              return Promise.resolve({ success: true, validClient: true });
            } else {
              return Promise.resolve({ success: true, validClient: false });
            }
          })
          .catch((error) => {
            dispatch.apiStatus.setProcessing(false);
            const decision = error?.rawResponse?.data?.eligibilityDecisions?.decisionContent;
            if (decision?.status === 'rejected' && decision?.rejectCode === 1) {
              return Promise.resolve({ success: true, validClient: false });
            } else if (decision?.status === 'rejected') {
              return Promise.resolve({ success: true, validClient: false });
            } else {
              dispatch.apiStatus.setRequestFailed({ ...error });
              track(SERVER_RESPONSE_FAILED, {
                ...generateServerResponseError(
                  error,
                  ACTIVATION,
                  'Get Document',
                  boAPI.validateClient,
                  'Get Client Document API'
                ),
              });
              track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Document') });
              return Promise.resolve({ success: false });
            }
          });
      },
    };
  },
};
